import Vue from 'vue';

const requireComponent = require.context('./', false, /base-[\w-]+\.vue$/);

requireComponent.keys().forEach(filename => {
  const componentConfig = requireComponent(filename);
  const componentName = filename.replace(/^\.\/base-/, '').replace(/\..+$/, '');
  Vue.component(componentName, componentConfig.default || componentConfig);
});
